import { FC } from 'react';
import { ServicesAll } from './ServicesAll/ServicesAll';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';

export const ServicesAllPage: FC = () => {
  return (
    <PageTemplate pageName="servicesAll" title="サービス" showNavBack>
      <ServicesAll />
    </PageTemplate>
  );
};
